<!-- ADMIN AREA -->
<div class="adminArea">
  <div class="helloAdmin" *ngIf="isAdmin"> Hi {{ adminNickName }}</div>
  <button *ngIf="newDataAvailable" id="newDataNotification" mat-raised-button (click)="manageNewData()">New data
    available
  </button>
  <div class="matTabGroup">
    <mat-tab-group>
      <div class="dataByUser">
        <mat-tab label="DATA BY USER">
          <div class="searchUser">
            <mat-form-field>
              <mat-label>
                <mat-icon style="font-size:large;">search</mat-icon>
                Search a user
              </mat-label>
              <textarea #myTextarea [value]="" matInput style="display: inline-block; font-size: 15.9px;"
                        cdkTextareaAutosize id="userSearchBar" (input)="onType()"></textarea>
            </mat-form-field>
          </div>
          <div style="display: flex; justify-content: center; padding-top: 3em;">
            <mat-form-field appearance="outline" style="width: 30em; font-size: 10px;">
              <mat-select [value]="selectedFilterByTask" style="font-size: 16px; padding-bottom: 3px;"
                          (selectionChange)="onFilterSelectionByTaskChange($event.value)">
                <mat-option value="AllUsers">All Users</mat-option>
                <mat-option value="Voucher">Voucher</mat-option>
                <mat-option value="NoVoucher">No Voucher</mat-option>
                <mat-option value="Italian">Italian</mat-option>
                <mat-option value="Spanish">Spanish</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="expansionPanels">
            <mat-accordion>
              <mat-expansion-panel *ngFor="let user of activeUsersShown" (opened)="panelOpenState = true"
                                   (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                  <mat-panel-title class="email">
                    {{ user.email }}
                  </mat-panel-title>
                  <mat-panel-description>
                    has completed {{ user.completed_tasks.length }} {{
                      user.completed_tasks.length ===
                      1 ?
                        'task' :
                        'tasks'
                    }}
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <table>
                  <tr>
                    <th>Voucher sent
                      <ng-container *ngIf="user.completed_tasks.length !== 10 && !isUserNoVoucher(user.email)">
                        <mat-checkbox disabled class="example-margin"></mat-checkbox>
                      </ng-container>
                      <ng-container *ngIf="user.completed_tasks.length === 10 && !isUserNoVoucher(user.email)">
                        <mat-checkbox [checked]="isChecked(user.email, 1)" class="example-margin"
                                      (click)="updateCheckboxVoucher(user.email)"></mat-checkbox>
                      </ng-container>
                      <ng-container *ngIf="isUserNoVoucher(user.email)">
                        <mat-checkbox disabled class="example-margin">No voucher ( {{ userNation(user.email) }})
                        </mat-checkbox>
                      </ng-container>
                    </th>
                  </tr>
                  <tr>
                    <th>
                      Active until: {{ isActiveUntil(user.email) }}
                    </th>
                  </tr>
                </table>
                <table>
                  <thead>
                  <tr>
                    <th>Completed Task</th>
                    <th>Timestamp</th>
                    <th> Data</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let t of user.completed_tasks">
                    <td>{{ t.completed_task }}</td>
                    <td>{{ t.timestamp }}</td>
                    <td>
                      <ng-container *ngIf="t.completed_task === 'Demographic'
                                 || t.completed_task === 'Covid'
                                 || t.completed_task === 'Fatigue'
                                 || t.completed_task === 'Quality'
                                 || t.completed_task === 'Personality'">

                        <button mat-raised-button
                                (click)="downloadQuestionnaireData(t.completed_task, user.user_id, user.email)"
                                [disabled]="t.user_id.split('_')[1]==='2' && ( t.completed_task === 'Covid'
                                                        || t.completed_task === 'Fatigue'
                                                        || t.completed_task === 'Quality')">Download
                        </button>
                      </ng-container>
                      <ng-container *ngIf="t.completed_task === 'FlashBeep'
                                || t.completed_task === 'LoudnessPerception'
                                || t.completed_task === 'MovementPerception'
                                || t.completed_task === 'TargetDetection'
                                || t.completed_task === 'WordCategorization' ">
                        <button mat-raised-button
                                (click)="downloadTaskData(t.completed_task, user.user_id, user.email)">Download
                        </button>
                      </ng-container>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </mat-tab>
      </div>
      <mat-tab label="DATA BY TASK">
        <div class="dataByTask">
          <div style="display: flex; justify-content: center; padding-top: 3em;">
            <mat-form-field appearance="outline" style="width: 30em; font-size: 10px;">
              <mat-select value="Covid" style="font-size: 16px;"
                          (selectionChange)="onSelectionChange($event.value)">
                <mat-option value="Covid">Covid Questionnaire</mat-option>
                <mat-option value="Demographic">Demographic Questionnaire</mat-option>
                <mat-option value="Fatigue">Fatigue Questionnaire</mat-option>
                <mat-option value="Personality">Personality Questionnaire</mat-option>
                <mat-option value="Quality">Quality Questionnaire</mat-option>
                <mat-option value="FlashBeep">Flash-Beep Task</mat-option>
                <mat-option value="LoudnessPerception">Loudness Perception Task</mat-option>
                <mat-option value="MovementPerception">Movement Perception Task</mat-option>
                <mat-option value="TargetDetection">Target Detection Task</mat-option>
                <mat-option value="WordCategorization">Word Categorization Task</mat-option>
                <mat-option value="UsersInfo">Users Info</mat-option>
                <mat-option value="Charlie">Charlie</mat-option>
                <mat-option value="FactorAnalysis">Factor Analysis</mat-option>
                <mat-option value="SeverityIndexes">Severity Indexes</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div style="display: flex; justify-content: center;" *ngIf="showAttemptSelector">
            <mat-form-field appearance="outline" style="width: 30em; font-size: 10px;">
              <mat-select value="0" style="font-size: 16px; padding-bottom: 3px;"
                          (selectionChange)="onAttemptSelectChange($event.value)">
                <mat-option value="1">1st Attempt</mat-option>
                <mat-option value="2">2nd Attempt</mat-option>
                <mat-option value="3">3rd Attempt</mat-option>
                <mat-option value="0">All Attempts</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div style="display: flex; justify-content: center; padding-top: 3em;">
            <mat-form-field appearance="outline" style="width: 30em; font-size: 10px;">
              <mat-select [value]="selectedFilterByTask" style="font-size: 16px; padding-bottom: 3px;"
                          (selectionChange)="onFilterSelectionByTaskChange($event.value)">
                <mat-option value="AllUsers">All Users</mat-option>
                <mat-option value="Voucher">Voucher</mat-option>
                <mat-option value="NoVoucher">No Voucher</mat-option>
                <mat-option value="Italian">Italian</mat-option>
                <mat-option value="Spanish">Spanish</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div style="display: flex; justify-content: center; padding: 1em;">
            <button mat-raised-button (click)="downloadSelectedTask()">Download</button>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="EXTEND USERS">
        <div class="searchUser">
          <mat-form-field class="search-bar">
            <mat-label>
              <mat-icon style="font-size:large;">search</mat-icon>
              Search a user
            </mat-label>
            <textarea matInput style="display: inline-block; font-size: 15.9px;"
                      cdkTextareaAutosize id="blockedUserSearchBar" (input)="onTypeBlockedUsers()"></textarea>
          </mat-form-field>
        </div>
        <div class="expansionPanels">
          <mat-accordion>
            <mat-expansion-panel *ngFor="let user of blockedUsersShown" (opened)="panelOpenState = true"
                                 (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <mat-panel-title class="email">
                  {{ user.email }}
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <button mat-raised-button (click)="extendTime(user,7)"> Extend 1 week</button>
              <button mat-raised-button (click)="extendTime(user,14)"> Extend 2 weeks</button>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-tab>
      <mat-tab label="TRANSLATION TOOLS">
        <div class="expansionPanels">
          <mat-accordion>
            <mat-expansion-panel *ngFor="let file of fileNames" (opened)="panelOpenState = true"
                                 (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <mat-panel-title>Convert {{ file }} to JSON</mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <mat-form-field>
                <mat-label>Choose a File</mat-label>
                <input type="file" (change)="handleFile($event)" #fileInput style="display:none;">
                <input matInput [value]="fileName" readonly>
                <button mat-button (click)="fileInput.click()">Browse</button>
                <button *ngIf="fileName==file" mat-button (click)="processFile('DownloadAll', 'all')">Download All
                </button>
              </mat-form-field>
              <div *ngIf="fileName==file">
                <mat-form-field>
                  <mat-label>Choose a language</mat-label>
                  <mat-select [(ngModel)]="selectedLanguage">
                    <mat-option *ngFor="let lang of updatableLanguages" [value]="lang">{{ lang }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <button *ngIf="selectedLanguage" mat-button
                        (click)="processFile('DownloadLang', selectedLanguage)">Download
                </button>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-tab>
      <mat-tab label="FACTOR ANALYSIS UPLOAD">
        <div class="expansionPanels">
          <mat-accordion>
            <mat-expansion-panel *ngFor="let file of fileNames" (opened)="panelOpenState = true"
                                 (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <mat-panel-title>Upload New Factor Analysis Excel</mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <mat-form-field>
                <mat-label>Choose a File</mat-label>
                <input type="file" (change)="handleFile($event)" #fileInput style="display:none;">
                <input matInput [value]="fileName" readonly>
                <button mat-button (click)="fileInput.click()">Browse</button>
                <button mat-button (click)="processFileFA('DownloadAll', 'all')">Upload Excel</button>
              </mat-form-field>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-tab>
      <mat-tab label="MANAGE USER ATTEMPTS">
        <div class="searchUser">
          <mat-form-field>
            <mat-label>
              <mat-icon style="font-size:large;">search</mat-icon>
              Search a user
            </mat-label>
            <textarea #myTextarea [value]="" matInput style="display: inline-block; font-size: 15.9px;"
                      cdkTextareaAutosize id="userSearch" (input)="onManageAttemptUserSearch()"></textarea>
          </mat-form-field>
        </div>
        <div style="display: flex; justify-content: center; padding-top: 3em;">
          <table>
            <thead>
            <tr>
              <th>Email</th>
              <th>Total Completed Tasks</th>
              <th>Current Attempt</th>
              <th>Current Attempt Completed Tasks</th>
              <th>New Attempt</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let user of attemptsList">
              <td>{{ user.email }}</td>
              <td>{{ user.completed_tasks }}</td>
              <td>{{ user.attempt }}</td>
              <td>{{ user.current_attempt_completed_tasks }}</td>
              <td>
                <button (click)="confirmCreateNewAttempt(user.user_id, $event)">Create New Attempt</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <!-- If you're not logged in or you don't have admin privileges, Thanos will send you back to the main page -->
  <div *ngIf="!isAdmin" class="overlay">
    <img class="image" src="https://www.gifcen.com/wp-content/uploads/2021/03/-2.gif" width="100%" alt="access denied">
  </div>
</div>
